import { render, staticRenderFns } from "./ChatComponent.vue?vue&type=template&id=80d584ac&"
import script from "./ChatComponent.vue?vue&type=script&lang=js&"
export * from "./ChatComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lpcms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80d584ac')) {
      api.createRecord('80d584ac', component.options)
    } else {
      api.reload('80d584ac', component.options)
    }
    module.hot.accept("./ChatComponent.vue?vue&type=template&id=80d584ac&", function () {
      api.rerender('80d584ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ChatComponent.vue"
export default component.exports